import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { HeaderModule } from '../../common/components/header/header.module';
import { FooterModule } from '../../common/components/footer/footer.module';
import { HeaderTopModule } from '../../common/components/header-top/header-top.module';
import { HomeModule } from '../../module/home/home.module';
import { CitizenModule } from '../../module/citizen/citizen.module';
import { SharedModule } from '../../common/shared/shared.module';
import { CommonLayoutComponent } from './citizen-layout.component';



@NgModule({
  declarations: [CommonLayoutComponent],
  imports: [
    CommonModule,
    RouterModule,
    HeaderTopModule,
    HeaderModule,
    FooterModule,
    HomeModule,
    CitizenModule,
    SharedModule
  ],
  exports: [CommonLayoutComponent]
})
export class CommonLayoutModule { }
